import * as Yup from 'yup';
import { IntegrationEnum } from 'models/InternalIntegrationSetting';

export const getCustomIntegrationFormSchema = (
  integrationEnum: IntegrationEnum,
) => {
  switch (integrationEnum) {
    case IntegrationEnum.TINYPNG:
    case IntegrationEnum.HELLOSIGN:
      return Yup.object({
        apiKey: Yup.string().required(),
      });

    case IntegrationEnum.MAILCHIMP:
      return Yup.object({
        apiKey: Yup.string().required(),
        audienceId: Yup.string().required(),
      });

    case IntegrationEnum.POINTCENTRAL:
      return Yup.object({
        login: Yup.string().required(),
        password: Yup.string().required(),
      });

    case IntegrationEnum.VACATIONRENTPAYMENT:
      return Yup.object({
        login: Yup.string().required(),
        password: Yup.string().required(),
        propertyCode: Yup.string().required(),
      });

    default:
      throw new Error('Invalid integration enum');
  }
};

export type CustomIntegrationFormSchemaType = {
  apiKey?: string;
  audienceId?: string;
  login?: string;
  password?: string;
  propertyCode?: string;
};
